/**
 * Layout/index.js
 * desc: page layout, includes optional header and/or nav
 * note: one tree for both shells — behind the "web.global.navigationV2.enabled" flag the legacy Nav gives way to the
 *       full-height Sidebar and the Header turns compact, while the page (the Outlet) keeps its position in the tree.
 *       That is what lets the flag be read live: LaunchDarkly boots from its localStorage cache and streams the real
 *       value after, and a change must apply without remounting the page underneath (which would abort its requests
 *       and drop its state)
 */
'use strict';

import Header from '../Header';
import Nav from '../Nav';
import Sidebar from '../Sidebar';
import { NAVIGATION_V2_FLAG } from '../Sidebar/config';
import { Outlet } from "react-router";
import LocationChangePrompt from '../../components/LocationChangePrompt';
import { useFlags } from 'launchdarkly-react-client-sdk';
import './styles.css';


const Layout = ({ children }) => {
    const featureFlags = useFlags();
    const isNavigationV2 = !!featureFlags[NAVIGATION_V2_FLAG];

    return (
        <div id="layout" className={ isNavigationV2 ? 'v2' : undefined } data-testid="app-shell">
            { isNavigationV2 ? <Sidebar/> : null }
            <div className="main">
                <Header variant={ isNavigationV2 ? 'compact' : 'default' }/>
                <div className="content">
                    <LocationChangePrompt />
                    { isNavigationV2 ? null : <Nav/> }
                    <Outlet />
                    { children }
                </div>
            </div>
        </div>
    );
};


export default Layout;
